import { Component, Input } from '@angular/core';
import { GenericBulkUpsertRecord, GenericFieldChange, GenericBulkUpsertAction } from '../models/generic-bulk-upsert.model';

@Component({
  selector: 'generic-upload-summary-table',
  templateUrl: './upload-summary-table.component.html'
})
export class GenericUploadSummaryTableComponent {
  @Input() records: GenericBulkUpsertRecord[] = [];
  @Input() changes: GenericFieldChange[] = [];
  @Input() fields: import('../models/generic-bulk-upsert.model').GenericBulkUpsertField[] = [];

  // Pagination
  currentPage = 1;
  pageSize = 15;

  get pagedRecords(): GenericBulkUpsertRecord[] {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.records.slice(start, end);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.currentPage = 1;
  }

  getFieldValue(record: GenericBulkUpsertRecord, fieldKey: string): string {
    return (record as any)[fieldKey] || '';
  }

  isChanged(rowIndex: number, fieldKey: string): boolean {
    return this.changes.some(c => c.rowIndex === rowIndex && c.field === fieldKey);
  }

  getChangeTooltip(rowIndex: number, fieldKey: string): string {
    const change = this.changes.find(c => c.rowIndex === rowIndex && c.field === fieldKey);
    if (change) {
      return `Changed from "${change.oldValue}" to "${change.newValue}"`;
    }
    return '';
  }

  getActionLabel(record: GenericBulkUpsertRecord): string {
    let action = 'No Change';
    
    if (record.action === GenericBulkUpsertAction.Update) {
      action = 'Updated';
    } else if (record.action === GenericBulkUpsertAction.Create) {
      action = 'Created';
    }

    return action;
  }
}
